import { createAction } from "@reduxjs/toolkit";

export const addStallRequest = createAction("addStallRequest");
export const addStallSuccess = createAction("addStallSuccess");
export const addStallFailure = createAction("addStallFailure");
